import Icon from "./IconBase.js";
const SearchCrossIcon = (props) => {
  return (
    <Icon width="18" height="18" viewBox="0 0 18 18" {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="9" fill="#F5F5F5" />
        <path
          d="M6 6L12 12"
          stroke="#0F0F0F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6L6 12"
          stroke="#0F0F0F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default SearchCrossIcon;
